import { useCallback, useEffect } from "react";

export default function useOnKeyDown(
  keys: string[],
  onKeyDown: (e: KeyboardEvent) => void,
  condition?: boolean,
) {
  const callback = useCallback(
    (e: KeyboardEvent) => {
      if (condition !== undefined && !condition) return;
      if (!keys.includes(e.key)) return;
      onKeyDown(e);
    },
    [keys, onKeyDown, condition],
  );

  useEffect(() => {
    window.addEventListener("keydown", callback);
    return () => {
      window.removeEventListener("keydown", callback);
    };
  }, [callback]);
}
